<template>
    <footer class="footer">
        <h3>具体计算公式如下：</h3>
        <div class="content">本期应预扣预缴税额 =（累计收入-累计费用-累计免税收入-累计减除费用-累计依法确定的其他扣除）×预扣率-速算扣除数-累计减免税额-累计已预扣预缴税额</div>
        <div class="content">其中：累计费用，按累计收入乘以20%计算；累计减除费用，按照5000元/月乘以纳税人当年截至本月在本互联网平台企业连续取得劳务报酬的月份数计算。 </div>

        <h3>速算扣除方式：</h3>
        <table class="table">
            <thead>
                 <tr>
                    <th>级数</th>
                    <th>累计预扣预缴应纳税所得额</th>
                    <th>预扣率</th>
                    <th>速算扣除数</th>
                </tr>
            </thead>
            <tbody>
                 <tr>
                    <td>1</td>
                    <td>不超过36000元</td>
                    <td>3%</td>
                    <td>0</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>超过36000元至144000元的部分</td>
                    <td>10%</td>
                    <td>2520</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>超过144000元至300000元的部分</td>
                    <td>20%</td>
                    <td>16920</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>超过300000元至420000元的部分</td>
                    <td>25%</td>
                    <td>31920</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>超过420000元至660000元的部分</td>
                    <td>30%</td>
                    <td>52920</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>超过660000元至960000元的部分</td>
                    <td>35%</td>
                    <td>82920</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>超过960000元的部分</td>
                    <td>45%</td>
                    <td>181920</td>
                </tr>
            </tbody>
        </table>

        <h3>国家税务总局规范性文件：</h3>
        <div class="link">
            <a href="https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241477/content.html" target="_blank">1：国家税务总局公告2025年第15号《国家税务总局关于互联网平台企业报送涉税信息有关事项的公告》</a>
        </div>
        <div class="link">
            <a href="https://fgk.chinatax.gov.cn/zcfgk/c100015/c5241480/content.html" target="_blank">2：关于《国家税务总局关于互联网平台企业报送涉税信息有关事项的公告》的解读 </a>
        </div>
        <div class="link">
            <a href="https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241472/content.html" target="_blank">3：国家税务总局公告2025年第16号《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》</a>
        </div>
        <div class="link">
            <a href="https://fgk.chinatax.gov.cn/zcfgk/c100015/c5241475/content.html" target="_blank">4：关于《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》的解读</a>
        </div>
    </footer>
</template>
